import { RestClient } from '../rest-client';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

export class BaseService {
  private restClient: RestClient;

  protected readonly apiVersion: string;

  protected readonly baseUrl: string;

  constructor(baseUrl: string, apiVersion: string) {
    this.restClient = RestClient.getInstance();
    this.baseUrl = baseUrl;
    this.apiVersion = apiVersion;
  }

  private formatUrl(endpoint: string): string {
    return `${this.baseUrl}${this.apiVersion}${endpoint}`;
  }

  public get = <T = any>(
    endpoint: string,
    options: AxiosRequestConfig = {}
  ): Promise<AxiosResponse<T>> => {
    return this.restClient.get<T>(this.formatUrl(endpoint), options);
  };

  public put = <T = any>(
    endpoint: string,
    body: any,
    options: AxiosRequestConfig = {}
  ) => {
    return this.restClient.put<T>(this.formatUrl(endpoint), body, options);
  };

  public patch = <T = any>(
    endpoint: string,
    body: any,
    options: AxiosRequestConfig = {}
  ) => {
    return this.restClient.patch<T>(this.formatUrl(endpoint), body, options);
  };

  public post = <T = any>(
    endpoint: string,
    body: any,
    options: AxiosRequestConfig = {}
  ) => {
    return this.restClient.post<T>(this.formatUrl(endpoint), body, options);
  };

  public delete = <T = any>(
    endpoint: string,
    options: AxiosRequestConfig = {}
  ) => {
    return this.restClient.delete<T>(this.formatUrl(endpoint), options);
  };
}
